class StepManager {
    constructor(containerSelector) {
        this.containerSelector = containerSelector;
        this.selectedSteps = {};
        this.currentStep = null;
        this.nextStep = null;
        this.init();
    }

    init() {
        this.container = document.querySelector(this.containerSelector);
        this.steps = Array.from(this.container.querySelectorAll('.configurator'));
        this.steps.forEach((step, index) => {
            const stepKey = step.dataset.variantPickerGroup;
            this.selectedSteps[stepKey] = index === 0;
        });
        this.initEventListeners();
        this.listenToVariantChange();
        this.updateStepLocking();
    }

    listenToVariantChange() {
        document.addEventListener('variant:change', (event) => {
            this.handleDomUpdate();
            setTimeout(() => {
                this.scrollToNextStep(this.nextStep);
                setTimeout(() => {
                    this.openImages(this.nextStep);
                }, 500);

            }, 1000);

        });
    }

    initEventListeners() {
        this.steps.forEach((step) => {
            const stepKey = step.dataset.variantPickerGroup;
            const inputs = step.querySelectorAll('input[data-configurator-position]');
            step.removeEventListener('input', this.handleStepChange);
            step.removeEventListener('click', this.handleStepClick);
            step.addEventListener('input', (event) => this.handleStepChange(event, stepKey));
            step.addEventListener('click', (event) => this.handleStepClick(event, stepKey));
        });
    }

    handleStepClick(event, stepKey) {
        const target = event.target;
        if (target.matches('input[data-configurator-position]')) {
            this.handleStepChange(event, stepKey)
            setTimeout(() => {
                this.scrollToNextStep(this.nextStep);
            }, 1000);
        }
    }

    handleStepChange(event, stepKey) {
        const target = event.target;
        if (target.matches('input[data-configurator-position]')) {
            this.selectedSteps[stepKey] = true;
            const nextStep = this.getNextStep(stepKey);
            if (nextStep && !this.selectedSteps[nextStep]) {
                this.selectedSteps[nextStep] = true;
                this.currentStep = stepKey;
                this.nextStep = nextStep;
            }
            this.updateStepLocking();
        }
    }

    uncheckInputsOfNextStep(nextStepKey) {
        const nextStep = this.container.querySelector(`[data-variant-picker-group="${nextStepKey}"]`);
        if (nextStep) {
            const labels = nextStep.querySelectorAll('label');
            labels.forEach(label => {
                label.style.color = 'rgb(var(--text-color) / .65)';
                label.style.borderColor = 'rgb(var(--border-color))';
            });

        }
    }

    scrollToNextStep(nextStepKey) {
        const nextStep = this.container.querySelector(`[data-variant-picker-group="${nextStepKey}"]`);
        if (nextStep) {
            nextStep.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    openImages(nextStepKey) {
        const nextStep = this.container.querySelector(`[data-variant-picker-group="${nextStepKey}"]`);
        if (nextStep) {
            const optionValue = nextStep.querySelector('input[data-option-position]:checked').value
            if (optionValue) {
                const item = nextStep.querySelector(`.block-swatch-image[data-option-value="${optionValue}"]`);
                if (item) {
                    const siblings = item.parentElement.querySelectorAll('label');
                    siblings.forEach(sibling => {
                        sibling.classList.remove('selected');
                    });
                    item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                    item.classList.add('selected');
                }
            }
        }
    }

    scrollToCurrentStep() {
        if (this.currentStep) {
            const currentStep = this.container.querySelector(`[data-variant-picker-group="${this.currentStep}"]`);
            if (currentStep) {
                currentStep.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }

    handleDomUpdate() {
        this.container = document.querySelector(this.containerSelector);
        this.steps = Array.from(this.container.querySelectorAll('.configurator'));
        this.initEventListeners();
        this.updateStepLocking();
    }

    updateStepLocking() {
        this.steps.forEach((step) => {
            const stepKey = step.dataset.variantPickerGroup;
            if (this.selectedSteps[stepKey]) {
                step.classList.add('selected');
            } else {
                step.classList.remove('selected');
            }
        });
    }

    getNextStep(currentStepKey) {
        const stepKeys = this.steps.map(step => step.dataset.variantPickerGroup);
        const currentIndex = stepKeys.indexOf(currentStepKey);
        return currentIndex >= 0 && currentIndex < stepKeys.length - 1 ? stepKeys[currentIndex + 1] : null;
    }
}


document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.template-configurator')) {
        const stepManager = new StepManager('.product-info');
    }
});
